export Button from './Button'

export default from './Button'



// WEBPACK FOOTER //
// ./src/Button/index.js